import React, { useEffect, useState } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';

import ModalLoad from '../modal/ModalLoad.js';
import ModalPopupMessage from '../modal/ModalPopupMessage.js';

function HistoricalDataEnergyCross(props) {
    const [datalist, setDataList] = useState({
        table_header: '-',
        list: [],
    });
    const [dataitem, setDataItem] = useState({
        list: [],
        total_meter: 1,
        table_header: '-',
    });

    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [modal_item, setModal_item] = useState(false);
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setDataList({
                list: [],
                table_header: '-',
            })
            setDataItem({
                list: [],
                total_meter: 1,
                table_header: '-',
            })
        };
    }, []);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
    }

    async function api_query_day() {
        let dt = dayjs(new Date(reportdate_dt)).format("YYYY")

        setmodal_load({ enable: true, message: "Query historical energy cross period track." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportyear', dt)
        formData.append('reportsite', props.permitdata.sitecode)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/energycross/getday", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.deduct !== null) {
                        setDataList(response.data.deduct)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_query_minite(datetime, sitecode) {
        let dt = dayjs(new Date(reportdate_dt)).format("YYYY")

        setmodal_load({ enable: true, message: "Query historical energy cross period track." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportdate', datetime)
        formData.append('reportsite', sitecode)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/energycross/getminute", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.deduct !== null) {
                        setDataItem(response.data.deduct)
                        setModal_item(true)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function close_popup() {
        setModal_item(false)
        setDataItem({
            list: [],
            total_meter: 1,
            table_header: '-',
        })
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Energy Cross Period</h4>
                                    <p className="mb-0">Validate energy crossed period</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        <div className="d-block " style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Year</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={'year'}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query_day() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                        </div>
                    </div>

                    <h5 className='mt-3'>Query Result : {datalist.table_header}</h5>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered text-nowrap" >
                            <thead>
                                <tr className="admintable-header">
                                    <th style={{ width: "110px" }}>Date</th>
                                    <th>Site Name</th>
                                    <th>Meter 1 Energy Cross (kWh)</th>
                                    <th>Meter 2 Energy Cross (kWh)</th>
                                    <th>Meter 3 Energy Cross (kWh)</th>
                                    <th>Last Update</th>
                                    <th rowSpan={2}>Detail</th>
                                </tr>
                            </thead>
                            <tbody id="tablebody">
                                {
                                    datalist.list.map((data, index) => (
                                        <tr key={index}>
                                            <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp}</td>
                                            <td>{data.sitename}</td>
                                            <td>{data.meter1_deduct}</td>
                                            <td>{data.total_meter > 1 ? data.meter2_deduct : "-"}</td>
                                            <td>{data.total_meter > 2 ? data.meter3_deduct : "-"}</td>
                                            <td>{data.last_update}</td>
                                            <td>
                                                <Link className="btn btn-icon btn-sm btn-success btn-hover btn-bordered" title="Details"
                                                    onClick={() => { api_query_minite(data.datetimestamp, data.sitecode) }}><i className="fas fa-search"></i></Link>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> Energy Cross Period Detail</h4>
                                                <i className="fe-x modal-close" onClick={() => { close_popup() }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <h5 className='mt-1'>Energy Cross Period - {dataitem.table_header}</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-stripedv table-bordered text-nowrap" >
                                                        <thead>
                                                            <tr style={{ backgroundColor: "white" }}>
                                                                <th style={{ width: "110px" }} rowSpan={2}>Date</th>
                                                                <th rowSpan={2}>Site Code</th>
                                                                <th colSpan={2} className='text-center'>Meter 1</th>
                                                                {
                                                                    dataitem.total_meter > 1 ?
                                                                        <th colSpan={2} className='text-center'>Meter 2</th> : null
                                                                }
                                                                {
                                                                    dataitem.total_meter > 2 ?
                                                                        <th colSpan={2} className='text-center'>Meter 3</th> : null
                                                                }
                                                            </tr>
                                                            <tr style={{ backgroundColor: "white" }}>
                                                                <th className='text-center'>Energy (kWh)</th>
                                                                <th className='text-center'>Last Connect</th>
                                                                {
                                                                    dataitem.total_meter > 1 ?
                                                                        <th className='text-center'>Energy (kWh)</th> : null
                                                                }
                                                                {
                                                                    dataitem.total_meter > 1 ?
                                                                        <th className='text-center'>Last Connect</th> : null
                                                                }
                                                                {
                                                                    dataitem.total_meter > 2 ?
                                                                        <th className='text-center'>Energy (kWh)</th> : null
                                                                }
                                                                {
                                                                    dataitem.total_meter > 2 ?
                                                                        <th className='text-center'>Last Connect</th> : null
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody id="tablebody">
                                                            {
                                                                dataitem.list.map((data, index) => (
                                                                    <tr key={data.datetimestamp}>
                                                                        <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp}</td>
                                                                        <td className='font-sarabun'>{data.sitecode}</td>
                                                                        <td className='text-center'>{data.meter1_deduct}</td>
                                                                        <td className='text-center'>{data.meter1_lasttime}</td>
                                                                        {
                                                                            dataitem.total_meter > 1 ?
                                                                                <td className='text-center'>{data.meter2_deduct}</td> : null
                                                                        }
                                                                        {
                                                                            dataitem.total_meter > 1 ?
                                                                                <td className='text-center'>{data.meter2_lasttime}</td> : null
                                                                        }
                                                                        {
                                                                            dataitem.total_meter > 2 ?
                                                                                <td className='text-center'>{data.meter3_deduct}</td> : null
                                                                        }
                                                                        {
                                                                            dataitem.total_meter > 2 ?
                                                                                <td className='text-center'>{data.meter3_lasttime}</td> : null
                                                                        }
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { close_popup() }}><i className="fe-x"></i> Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>

            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataEnergyCross